import { motion } from 'framer-motion';

const RoadmapSection = () => {
  const roadmapItems = [
    {
      status: 'completed',
      platform: 'ManageEngine',
      logo: 'https://static.readdy.ai/image/9c916c921dab6b7efa0ebb131a6ff24b/745abf2060d327600b7ab257b8575c0f.webp',
      color: 'bg-green-500',
      iconColor: 'text-green-500',
      description: 'Tam entegrasyon tamamlandı'
    },
    {
      status: 'in-progress',
      platform: 'ServiceNow',
      quarter: '2026',
      logo: 'https://public.readdy.ai/ai/img_res/760b610e2a56d060958a9119ef190c57.jpg',
      color: 'bg-orange-500',
      iconColor: 'text-orange-500',
      description: 'Geliştirme aşamasında'
    },
    {
      status: 'planned',
      platform: 'Jira & Freshservice',
      quarter: '2026',
      logo: 'https://readdy.ai/api/search-image?query=Jira%20Service%20Management%20and%20Freshservice%20official%20logos%20combined%20on%20white%20background%2C%20clean%20corporate%20branding%2C%20professional%20software%20company%20logos&width=120&height=60&seq=roadmap-jira-fresh&orientation=landscape',
      color: 'bg-gray-400',
      iconColor: 'text-gray-400',
      description: 'Planlama aşamasında'
    }
  ];

  return (
    <section id="roadmap" className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-5 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-2 space-y-6"
          >
            <h2 className="text-5xl font-bold text-[#1A2B4A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Geleceğe Hazır Altyapı
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed">
              <strong className="text-[#FF6B35]">Çok Yakında:</strong> ServiceNow, Jira Service Management ve Freshservice desteğiyle tüm IT dünyasının hizmetindeyiz.
            </p>
            <div className="flex items-center space-x-3 text-gray-600">
              <i className="ri-rocket-line text-2xl text-[#FF6B35]"></i>
              <span className="font-medium">Sürekli genişleyen entegrasyon ekosistemi</span>
            </div>
          </motion.div>

          <div className="lg:col-span-3">
            <div className="relative">
              <div className="absolute left-8 top-0 bottom-0 w-1 bg-gradient-to-b from-green-500 via-orange-500 to-gray-300"></div>

              <div className="space-y-12">
                {roadmapItems.map((item, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: index * 0.2 }}
                    className="relative flex items-start space-x-6"
                  >
                    <div className={`relative z-10 w-16 h-16 rounded-full ${item.color} flex items-center justify-center shadow-lg`}>
                      {item.status === 'completed' && (
                        <i className="ri-check-line text-3xl text-white"></i>
                      )}
                      {item.status === 'in-progress' && (
                        <motion.i
                          animate={{ rotate: 360 }}
                          transition={{ duration: 2, repeat: Infinity, ease: 'linear' }}
                          className="ri-loader-4-line text-3xl text-white"
                        ></motion.i>
                      )}
                      {item.status === 'planned' && (
                        <i className="ri-time-line text-3xl text-white"></i>
                      )}
                    </div>

                    <div className="flex-1 bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all">
                      <div className="flex items-center justify-between mb-4">
                        <h3 className="text-2xl font-bold text-[#1A2B4A]">{item.platform}</h3>
                        {item.quarter && (
                          <span className="px-4 py-2 bg-orange-100 text-orange-700 rounded-full text-sm font-bold">
                            {item.quarter}
                          </span>
                        )}
                      </div>
                      <p className="text-gray-600">{item.description}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RoadmapSection;
